import { repositoryDispatcher } from '..';

let msgId = 0;

export const messageDispatcher = dispatch => ( {
  addMessage( message ) {
    message.id = ++msgId;
    if ( message.timeout > 0 ) {
      setTimeout( () => this.removeMessage( message ), message.timeout );
    }
    return repositoryDispatcher( 'message' )( dispatch ).put( message );
  },
  removeMessage( message ) {
    return repositoryDispatcher( 'message' )( dispatch ).remove( message );
  }
} );